export default function getMonthName(date = new Date()){
    const months = ['янв', 'фер', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'нНоя', 'дек']
    let month = date.getMonth()
    month = months[month]
    return month
}